import {FormUnit} from '../../commands/flowline/flowline.commands';

declare const mxConstants: any;
declare const mxMarker: any;
declare const mxUtils: any;

import * as _ from 'lodash';

const FlowlineFormUtil = (function () {
  register();

  const forms = <any>{},
    get = {
      mxState: getMxState,
      titleListOf: getTitleListOf,
      formSet: getFormSet,

      shape: {byTitle: shapeByTitle, keysFor: shapeKeysFor},
      type: {byTitle: typeByTitle, keysFor: typeKeysFor},
      end: {byTitle: endsByTitle, keysFor: endsKeysFor},
      start: {byTitle: startByTitle, keysFor: startKeysFor}
    },
    is = {
      string: function (data) {
        return typeof data === 'string';
      },
      straight: function (key, val) {
        return key === mx.keys.waypoints && val === mx.vals.none;
      },

      orthogonal: function (key, val) {
        return key === mx.keys.waypoints && val === mx.vals.orthogonal;
      },
      resetPoints: function (oldShape, newShape) {
        if (oldShape === newShape) {
          return false;
        }

        const isCurved = function (shape) {
            return shape === 'Curved';
          },
          isOrthogon = function (shape) {
            return shape === 'Orthogonal';
          };

        return !(
          (isCurved(oldShape) && isOrthogon(newShape)) ||
          (isCurved(newShape) && isOrthogon(oldShape))
        );
      }
    };

  const mx = {
    noArrowVal: 'None',
    vals: {
      enable: '1',
      disable: '0',
      none: 'none',

      classic: 'classic',
      blockThin: mxConstants.ARROW_BLOCK_THIN,
      diamond: mxConstants.ARROW_DIAMOND,
      ERone: 'ERone',
      ERmany: 'ERmany',
      ERmandOne: 'ERmandOne',
      ERoneToMany: 'ERoneToMany',
      ERzeroToOne: 'ERzeroToOne',
      ERzeroToMany: 'ERzeroToMany',

      orthogonal: 'orthogonalEdgeStyle',
      dottedPattern: '1 4'
    },
    keys: {
      curved: 'curved',
      dashed: 'dashed',
      dotted: 'dashPattern', // 1 4

      waypoints: 'edgeStyle',
      endArrow: 'endArrow',
      startArrow: 'startArrow'
    }
  };

  forms.shape = [
    form('Straight', 'flowline_icons:flowline_straight', 'EDITOR.FL_STRAIGHT', [
      {key: mx.keys.curved, val: mx.vals.disable},
      {key: mx.keys.waypoints, val: mx.vals.none}
    ]),
    form('Curved', 'flowline_icons:flowline_curved', 'EDITOR.FL_CURVED', [
      mx.keys.curved,
      {key: mx.keys.waypoints, val: mx.vals.none},
      {key: mx.keys.waypoints, val: mx.vals.orthogonal}
    ]),
    form('Orthogonal', 'flowline_icons:flowline_orthogonal', 'EDITOR.FL_ORTHO', [
      {key: mx.keys.curved, val: mx.vals.disable},
      {key: mx.keys.waypoints, val: mx.vals.orthogonal}
    ])
  ];

  forms.type = [
    form('Dashed', 'flowline_icons:flowline_dashed', 'EDITOR.FL_DASHED', [
      mx.keys.dashed,
      {key: mx.keys.dotted, val: mx.vals.none}
    ]),
    form('Dotted', 'flowline_icons:flowline_dotted', 'EDITOR.FL_DOTTED', [
      mx.keys.dashed,
      {key: mx.keys.dotted, val: mx.vals.dottedPattern}
    ]),
    form('Solid', 'flowline_icons:flowline_normal', 'EDITOR.FL_NORMAL', [
      {key: mx.keys.dashed, val: mx.vals.disable},
      {key: mx.keys.dotted, val: mx.vals.none}
    ])
  ];

  forms.start = [
    form(
      'None',
      'flowline_icons:flowline_none',
      'EDITOR.FL_NONE',
      [{key: mx.keys.startArrow, val: mx.vals.none}, 'startFill'],
      true
    ),

    form('Block Thin', 'flowline_icons:flowline_start_fullarrow', 'EDITOR.FL_THIN', [
      {key: mx.keys.startArrow, val: mx.vals.blockThin},
      'startFill'
    ]),
    form('Classic', 'flowline_icons:flowline_start_classic', 'EDITOR.FL_CLASSIC', [
      {key: mx.keys.startArrow, val: mx.vals.classic},
      'startFill'
    ]),
    form('Diamond', 'flowline_icons:flowline_start_diamond', 'EDITOR.FL_DIAMOND', [
      {key: mx.keys.startArrow, val: mx.vals.diamond},
      {key: 'startFill', val: mx.vals.disable}
    ]),
    form('ERzeroToOne', 'flowline_icons:flowline_start_', 'EDITOR.FL_ZERO_ONE', [
      {key: mx.keys.startArrow, val: mx.vals.ERzeroToOne},
      'startFill'
    ]),
    form('ERmandOne', 'flowline_icons:flowline_start_mandatory_one', 'EDITOR.FL_M_ONE', [
      {key: mx.keys.startArrow, val: mx.vals.ERmandOne},
      'startFill'
    ]),
    form('ERone', 'flowline_icons:flowline_start_one', 'EDITOR.FL_ONE', [
      {key: mx.keys.startArrow, val: mx.vals.ERone},
      'startFill'
    ]),
    form('ERzeroToMany', 'flowline_icons:flowline_start_zero_many', 'EDITOR.FL_ZERO_MANY', [
      {key: mx.keys.startArrow, val: mx.vals.ERzeroToMany},
      'startFill'
    ]),
    form('ERmany', 'flowline_icons:flowline_start_many', 'EDITOR.FL_MANY', [
      {key: mx.keys.startArrow, val: mx.vals.ERmany},
      'startFill'
    ]),
    form('ERoneToMany', 'flowline_icons:flowline_start_one_many', 'EDITOR.FL_ONE_MANY', [
      {key: mx.keys.startArrow, val: mx.vals.ERoneToMany},
      'startFill'
    ])
  ];

  forms.end = [
    form(
      'None',
      'flowline_icons:flowline_none',
      'EDITOR.FL_NONE',
      [{key: mx.keys.endArrow, val: mx.vals.none}, 'endFill'],
      true
    ),

    form('Block Thin', 'flowline_icons:flowline_end_', 'EDITOR.FL_THIN', [
      {key: mx.keys.endArrow, val: mx.vals.blockThin},
      'endFill'
    ]),
    form('Classic', 'flowline_icons:flowline_end_classic', 'EDITOR.FL_CLASSIC', [
      {key: mx.keys.endArrow, val: mx.vals.classic},
      'endFill'
    ]),
    form('Diamond', 'flowline_icons:flowline_end_diamond', 'EDITOR.FL_DIAMOND', [
      {key: mx.keys.endArrow, val: mx.vals.diamond},
      {key: 'endFill', val: mx.vals.disable}
    ]),
    form('ERzeroToOne', 'flowline_icons:flowline_end_zero_one', 'EDITOR.FL_ZERO_ONE', [
      {key: mx.keys.endArrow, val: mx.vals.ERzeroToOne},
      'endFill'
    ]),
    form('ERmandOne', 'flowline_icons:flowline_end_mandatory_one', 'EDITOR.FL_M_ONE', [
      {key: mx.keys.endArrow, val: mx.vals.ERmandOne},
      'endFill'
    ]),
    form('ERone', 'flowline_icons:flowline_end_one', 'EDITOR.FL_ONE', [
      {key: mx.keys.endArrow, val: mx.vals.ERone},
      'endFill'
    ]),
    form('ERzeroToMany', 'flowline_icons:flowline_end_zero_many', 'EDITOR.FL_ZERO_MANY', [
      {key: mx.keys.endArrow, val: mx.vals.ERzeroToMany},
      'endFill'
    ]),
    form('ERmany', 'flowline_icons:flowline_end_many', 'EDITOR.FL_MANY', [
      {key: mx.keys.endArrow, val: mx.vals.ERmany},
      'endFill'
    ]),
    form('ERoneToMany', 'flowline_icons:flowline_end_one_many', 'EDITOR.FL_ONE_MANY', [
      {key: mx.keys.endArrow, val: mx.vals.ERoneToMany},
      'endFill'
    ])
  ];

  function shapeKeysFor(title) {
    return !is.string(title) ? false : _findFormByTitle(forms.shape, title).props;
  }

  function typeKeysFor(title) {
    return !is.string(title) ? false : _findFormByTitle(forms.type, title).props;
  }

  function endsKeysFor(title) {
    return !is.string(title) ? false : _findFormByTitle(forms.end, title).props;
  }

  function startKeysFor(title) {
    return !is.string(title) ? false : _findFormByTitle(forms.start, title).props;
  }

  function shapeByTitle(title) {
    return !is.string(title) ? false : _findFormByTitle(forms.shape, title);
  }

  function typeByTitle(title) {
    return !is.string(title) ? false : _findFormByTitle(forms.type, title);
  }

  function endsByTitle(title) {
    return !is.string(title) ? false : _findFormByTitle(forms.end, title);
  }

  function startByTitle(title) {
    return !is.string(title) ? false : _findFormByTitle(forms.start, title);
  }

  function getFormSet(setName): Array<FormUnit> {
    return !is.string(setName) && !forms[setName] ? false : forms[setName].filter(f => !f.hidden);
  }

  function getTitleListOf(type) {
    return !forms[type] ? false : _mapBy(forms[type], 'title');
  }

  function getMxState(state) {
    return _.transform(newFormsItem(state), function (target, val, key) {
      const keyValItems = get[key].keysFor(state[key]);

      _.assign(target, _getItemMxState(keyValItems));
    });
  }

  function newFormsItem(data) {
    data = data || {};

    return {
      shape: data.shape || 'Orthogonal',
      type: data.type || 'Solid',
      start: data.start || 'None',
      end: data.end || 'Classic'
    };
  }

  function _getItemMxState(arr) {
    return _.transform(
      arr,
      function (target, item: any) {
        return (target[item.key] = item.val);
      },
      {}
    );
  }

  function _findFormByTitle(data, param) {
    return _.find(data, function (item) {
      return item.title.toLowerCase() === param.toLowerCase();
    });
  }

  function _mapBy(data, prop) {
    return _.map(data, function (item) {
      return item[prop];
    });
  }

  function form(title, icon, tooltip, props, hidden = false) {
    return {title: title, icon: icon, tooltip: tooltip, hidden, props: setProps(props)};

    function setProps(properties) {
      return _.map(properties, function (property) {
        if (is.string(property)) {
          return {key: property, val: mx.vals.enable};
        } else {
          return {key: property.key, val: property.val || mx.vals.enable};
        }
      });
    }
  }

  function register() {
    // defining each needed line endings
    mxMarker.addMarker(
      'ERone',
      function (c, shape, type, pe, unitX, unitY, size, source, sw, filled) {
        const nx = unitX * (size + sw + 1);
        const ny = unitY * (size + sw + 1);

        return function () {
          c.begin();
          c.moveTo(pe.x - nx / 2 - ny / 2, pe.y - ny / 2 + nx / 2);
          c.lineTo(pe.x - nx / 2 + ny / 2, pe.y - ny / 2 - nx / 2);
          c.stroke();
        };
      }
    );

    mxMarker.addMarker(
      'ERmany',
      function (c, shape, type, pe, unitX, unitY, size, source, sw, filled) {
        const nx = unitX * (size + sw + 1);
        const ny = unitY * (size + sw + 1);

        return function () {
          c.begin();
          c.moveTo(pe.x + ny / 2, pe.y - nx / 2);
          c.lineTo(pe.x - nx, pe.y - ny);
          c.lineTo(pe.x - ny / 2, pe.y + nx / 2);
          c.stroke();
        };
      }
    );

    mxMarker.addMarker(
      'ERmandOne',
      function (c, shape, type, pe, unitX, unitY, size, source, sw, filled) {
        const nx = unitX * (size + sw + 1);
        const ny = unitY * (size + sw + 1);

        return function () {
          c.begin();
          c.moveTo(pe.x - nx / 2 - ny / 2, pe.y - ny / 2 + nx / 2);
          c.lineTo(pe.x - nx / 2 + ny / 2, pe.y - ny / 2 - nx / 2);
          c.moveTo(pe.x - nx - ny / 2, pe.y - ny + nx / 2);
          c.lineTo(pe.x - nx + ny / 2, pe.y - ny - nx / 2);
          c.stroke();
        };
      }
    );

    mxMarker.addMarker(
      'ERoneToMany',
      function (c, shape, type, pe, unitX, unitY, size, source, sw, filled) {
        const nx = unitX * (size + sw + 1);
        const ny = unitY * (size + sw + 1);

        return function () {
          c.begin();
          c.moveTo(pe.x - nx - ny / 2, pe.y - ny + nx / 2);
          c.lineTo(pe.x - nx + ny / 2, pe.y - ny - nx / 2);
          c.moveTo(pe.x + ny / 2, pe.y - nx / 2);
          c.lineTo(pe.x - nx, pe.y - ny);
          c.lineTo(pe.x - ny / 2, pe.y + nx / 2);
          c.stroke();
        };
      }
    );

    mxMarker.addMarker(
      'ERzeroToOne',
      function (c, shape, type, pe, unitX, unitY, size, source, sw, filled) {
        const nx = unitX * (size + sw + 1);
        const ny = unitY * (size + sw + 1);
        const a = size / 2;

        return function () {
          c.begin();
          c.ellipse(pe.x - 1.5 * nx - a, pe.y - 1.5 * ny - a, 2 * a, 2 * a);

          if (filled) {
            const oldColor = mxUtils.getValue(
              shape.style,
              mxConstants.STYLE_STROKECOLOR,
              '#666666'
            );

            c.setFillColor('#ffffff');
            c.fillAndStroke();
            c.setFillColor(oldColor);
          } else {
            c.stroke();
          }

          c.begin();
          c.moveTo(pe.x - nx / 2 - ny / 2, pe.y - ny / 2 + nx / 2);
          c.lineTo(pe.x - nx / 2 + ny / 2, pe.y - ny / 2 - nx / 2);
          c.stroke();
        };
      }
    );

    mxMarker.addMarker(
      'ERzeroToMany',
      function (c, shape, type, pe, unitX, unitY, size, source, sw, filled) {
        const nx = unitX * (size + sw + 1);
        const ny = unitY * (size + sw + 1);
        const a = size / 2;

        return function () {
          c.begin();
          c.ellipse(pe.x - 1.5 * nx - a, pe.y - 1.5 * ny - a, 2 * a, 2 * a);

          if (filled) {
            const oldColor = mxUtils.getValue(
              shape.style,
              mxConstants.STYLE_STROKECOLOR,
              '#666666'
            );

            c.setFillColor('#ffffff');
            c.fillAndStroke();
            c.setFillColor(oldColor);
          } else {
            c.stroke();
          }

          c.begin();
          c.moveTo(pe.x + ny / 2, pe.y - nx / 2);
          c.lineTo(pe.x - nx, pe.y - ny);
          c.lineTo(pe.x - ny / 2, pe.y + nx / 2);
          c.stroke();
        };
      }
    );
  }

  return {
    get,
    newFormsItem,
    is,
    mx
  };
})();

export {FlowlineFormUtil};
